/**
 * @generated SignedSource<<c2682d2b7c1e061bc6ca2ba9a386cbd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleAdminItemTimeIndicator_RoutineScheduleDaily$data = {
  readonly deadlineDuration: number | null;
  readonly weekdays: ReadonlyArray<{
    readonly startTime: {
      readonly hour: number;
      readonly minute: number;
    } | null;
  }>;
  readonly " $fragmentType": "TeamScheduleAdminItemTimeIndicator_RoutineScheduleDaily";
};
export type TeamScheduleAdminItemTimeIndicator_RoutineScheduleDaily$key = {
  readonly " $data"?: TeamScheduleAdminItemTimeIndicator_RoutineScheduleDaily$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleAdminItemTimeIndicator_RoutineScheduleDaily">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleAdminItemTimeIndicator_RoutineScheduleDaily",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineScheduleDailyWeekday",
      "kind": "LinkedField",
      "name": "weekdays",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Time",
          "kind": "LinkedField",
          "name": "startTime",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hour",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minute",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadlineDuration",
      "storageKey": null
    }
  ],
  "type": "RoutineScheduleDaily",
  "abstractKey": null
};

(node as any).hash = "60fc821e390e71c532d0d158a939003d";

export default node;
